import * as React from "react";

const NotificationsInfo: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" fill="currentColor">
            <path
                fill="#53ACDB"
                d="M9 18a9 9 0 0 0 9-9c0-4.969-4.03-9-9-9S0 4.031 0 9a9 9 0 0 0 9 9ZM9 7.04a1.524 1.524 0 1 1 0-3.048A1.524 1.524 0 0 1 9 7.04Zm1.597 6.605H7.403a.436.436 0 0 1-.435-.435v-.871c0-.24.195-.436.435-.436h.436V9.581h-.436a.436.436 0 0 1-.435-.436v-.87c0-.241.195-.436.435-.436h2.323c.24 0 .435.195.435.435v3.63h.436c.24 0 .435.194.435.435v.87c0 .241-.195.436-.435.436Z"
            />
        </svg>
    );
};

export default React.memo(NotificationsInfo);
